import React from 'react';
import Hero from './components/Hero';
import './App.css';

const App = () => <Hero />

export default App;
